import { ConditionTypeDetailsProps } from "@redotech/redo-return-ui/flows/return-flow/condition";
import { WrongProductState } from "@redotech/redo-return-ui/flows/return-flow/condition-types/wrong-product";
import { Flex } from "@redotech/redo-web/flex";
import { Text } from "@redotech/redo-web/text";
import { memo } from "react";

export const WrongProductDetails = memo(function WrongProductDetails({
  disabled,
}: ConditionTypeDetailsProps<WrongProductState>) {
  return (
    <Flex dir="column" gap="xs">
      <Text fontSize="xs" fontWeight="medium" textColor="secondary">
        Condition
      </Text>
      <Text fontSize="xxs" fontWeight="regular" textColor="tertiary">
        Applies when at least one item in the return is submitted as a wrong
        product.
      </Text>
    </Flex>
  );
});
